<template>
  <div class="menu-container">
<!--    <div class="menu-header">
      <i class="el-icon-s-grid"></i>
      <span>功能菜单</span>
    </div> -->

    <el-menu
      :default-active="$route.path"
      :collapse="false"
      class="custom-menu"
      @open="handleOpen"
      @close="handleClose"
      :default-openeds="openeds"
      router>

      <!-- 创建新表 -->
      <el-submenu index="0" class="menu-group">
        <template slot="title">
          <div class="menu-title">
            <i class="el-icon-circle-plus-outline"></i>
            <span>创建新表</span>
          </div>
        </template>

        <el-tooltip class="item" effect="dark" content="使用前一定要读哦" placement="right">
          <el-menu-item index="/read_me" class="menu-item">
            <i class="el-icon-reading"></i>
            <span>使用必读</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="手工制作一个表格" placement="right">
          <el-menu-item index="/make_form" class="menu-item">
            <i class="el-icon-edit-outline"></i>
            <span>手工制作空表</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="导入现有的excel表格文件，制作手机端填写表格" placement="right">
          <el-menu-item index="/import_data_excel" class="menu-item">
            <i class="el-icon-upload2"></i>
            <span>导入Excel空表</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="导入现有的excel表格文件，用于核对信息" placement="right">
          <el-menu-item index="/import_checking" class="menu-item">
            <i class="el-icon-document-checked"></i>
            <span>导入Excel数据表</span>
          </el-menu-item>
        </el-tooltip>
      </el-submenu>

      <!-- 表格管理 -->
      <el-submenu index="1" class="menu-group">
        <template slot="title">
          <div class="menu-title">
            <i class="el-icon-s-management"></i>
            <span>表格管理</span>
            <span v-if="myform_count + invited_count > 0" class="menu-badge">{{myform_count + invited_count}}</span>
          </div>
        </template>

        <el-tooltip class="item" effect="dark" content="管理我发出去的表格" placement="right">
          <el-menu-item index="/form_list" class="menu-item">
            <i class="el-icon-s-order"></i>
            <span>我管理的表</span>
            <span v-if="myform_count > 0" class="item-badge blue">{{myform_count}}</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="别人授权或邀请我管理的表格" placement="right">
          <el-menu-item index="/invited_form_list" class="menu-item">
            <i class="el-icon-share"></i>
            <span>共享给我的表</span>
            <span v-if="invited_count > 0" class="item-badge green">{{invited_count}}</span>
          </el-menu-item>
        </el-tooltip>
      </el-submenu>

      <!-- 参数管理 -->
      <el-submenu index="2" class="menu-group">
        <template slot="title">
          <div class="menu-title">
            <i class="el-icon-s-tools"></i>
            <span>参数管理</span>
          </div>
        </template>

        <el-tooltip class="item" effect="dark" content="管理常用填表人" placement="right">
          <el-menu-item index="/inputer_list" class="menu-item">
            <i class="el-icon-user-solid"></i>
            <span>预设名单</span>
          </el-menu-item>
        </el-tooltip>
      </el-submenu>

    </el-menu>

    <!-- 底部装饰 -->
    <div class="menu-footer">
      <div class="menu-footer-text">多人填表 · 数据管理</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MenuList',
    data: function() {
      return {
        openeds: ['0', '1', '2'],
        username: '',
        activeIndex: '',
        invited_count: 0,
        myform_count: 0
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.setCurrentRoute()
      this.loadMenuNum()
    },
    watch: {
      $route() {
        this.setCurrentRoute()
      }
    },
    methods: {
      setCurrentRoute() {
        this.activeIndex = this.$route.path
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath)
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath)
      },
      helpShow() {
        console.log('用户名' + this.username)
        if (this.username === 'admin') {
          return true
        } else {
          return false
        }
      },
      loadMenuNum() {
        console.log('加载数据')
        let that = this
        var requestUrl = '/form/web/_load_menu_info.jsp'
        this.axios.get(requestUrl, {
          params: { username: that.username }
        }).then(function(response) {
          that.invited_count = response.data.invited_count
          that.myform_count = response.data.myform_count
        }).catch(function(error) {
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
  /* 菜单容器 */
  .menu-container {
    height: 100%;
    background: #fff;
    border-right: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;
  }

  /* 菜单头部 */
  .menu-header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    padding: 18px 20px;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .menu-header i {
    font-size: 20px;
  }

  /* 自定义菜单样式 */
  .custom-menu {
    border-right: none;
    flex: 1;
    background: #fff;
  }

  /* 菜单分组 */
  ::v-deep .menu-group .el-submenu__title {
    height: 50px;
    line-height: 50px;
    padding: 0 20px !important;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    transition: all 0.3s ease;
  }

  ::v-deep .menu-group .el-submenu__title:hover {
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%) !important;
    color: #1485FB;
  }

  ::v-deep .menu-group .el-submenu__title i {
    color: #1485FB;
    font-size: 18px;
    margin-right: 10px;
  }

  ::v-deep .menu-group.is-opened .el-submenu__title {
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
    color: #1485FB;
  }

  /* 菜单标题 */
  .menu-title {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .menu-badge {
    background: linear-gradient(135deg, #FFCB2F 0%, #ffb700 100%);
    color: #333;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    margin-left: auto;
    font-weight: 600;
  }

  /* 菜单项 */
  ::v-deep .menu-item {
    height: 44px;
    line-height: 44px;
    padding: 0 20px 0 50px !important;
    font-size: 14px;
    color: #555;
    transition: all 0.3s ease;
  }

  ::v-deep .menu-item:hover {
    background: #f5f7fa !important;
    color: #1485FB;
  }

  ::v-deep .menu-item.is-active {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%) !important;
    color: #fff !important;
    border-radius: 0 20px 20px 0;
    margin-right: 10px;
  }

  ::v-deep .menu-item i {
    margin-right: 8px;
    font-size: 16px;
  }

  ::v-deep .menu-item.is-active i {
    color: #fff;
  }

  /* 数字徽章 */
  .item-badge {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    margin-left: auto;
    font-weight: 600;
  }

  .item-badge.blue {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
  }

  .item-badge.green {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    color: #fff;
  }

  /* 底部装饰 */
  .menu-footer {
    padding: 15px;
    text-align: center;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
  }

  .menu-footer-text {
    font-size: 12px;
    color: #999;
    letter-spacing: 1px;
  }

  /* 覆盖Element UI默认样式 */
  ::v-deep .el-submenu .el-menu-item {
    min-width: auto;
  }

  ::v-deep .el-menu {
    background: transparent;
  }

  ::v-deep .el-submenu__icon-arrow {
    color: #999;
    font-size: 14px;
  }

  ::v-deep .menu-group.is-opened .el-submenu__icon-arrow {
    color: #1485FB;
  }

  /* Tooltip样式调整 */
  ::v-deep .el-tooltip__popper {
    max-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu.vue